import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../images/logo/TigrisPayLogo.png";
import MobileMenu from "../MobileMenu/MobileMenu";
import { FaChevronDown } from "react-icons/fa";
import "./CountrySubmenu.css";

const Header = (props) => {
  const [mobailActive, setMobailState] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showSubmenu, setShowSubmenu] = useState(false);

  // Country data
  const countries = [
    { name: "India", code: "INR", symbol: "₹", path: "/send-money-to-india", flag: "images/flags/inr.png" },
    { name: "Pakistan", code: "PKR", symbol: "Rs", path: "/send-money-to-pakistan", flag: "images/flags/pkr.png" },
    { name: "Bangladesh", code: "BDT", symbol: "৳", path: "/send-money-to-bangladesh", flag: "images/flags/bdt.png" },
    { name: "Nepal", code: "NPR", symbol: "रू", path: "/send-money-to-nepal", flag: "images/flags/npr.png" },
    // { name: "Nigeria", code: "NGN", symbol: "₦", path: "/send-money-to-nigeria", flag: "images/flags/ngn.png" },
    { name: "Sri Lanka", code: "LKR", symbol: "රු", path: "/send-money-to-sri-lanka", flag: "images/flags/lkr.png" },
    // { name: "Malaysia", code: "MYR", symbol: "RM", path: "/send-money-to-malaysia", flag: "images/flags/myr.png" },
    // { name: "Philippines", code: "PHP", symbol: "₱", path: "/send-money-to-philipphins", flag: "images/flags/php.png" }
  ];

  // Filter countries based on search query
  const filteredCountries = countries.filter(country => 
    country.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      id="xb-header-area"
      className="header-area header-style-two header-transparent"
    >
      <div
        className={`xb-header stricky ${
          isSticky ? "stricked-menu stricky-fixed" : ""
        }`}
      >
        <div className="container">
          <div className="header__wrap ul_li_between">
            {/* ===== LOGO ===== */}
            <div className="header-logo">
              <Link onClick={ClickHandler} to="/">
                <img src={logo} style={{ maxWidth: "120px" }} alt="TigrisPay" />
              </Link>
            </div>

            {/* ===== MAIN MENU ===== */}
            <div className="main-menu__wrap ul_li navbar navbar-expand-xl">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  <li className="menu-item-has-children">
                    <Link onClick={ClickHandler} to="/">
                      <span>Send Money</span>
                      <FaChevronDown
                        style={{ marginLeft: "6px", fontSize: "0.8em" }}
                      />
                    </Link>
                    <div className="submenu country-submenu">
                      <div className="country-search">
                        <input 
                          type="text" 
                          placeholder="Search country..." 
                          value={searchQuery}
                          onChange={handleSearchChange}
                        />
                      </div>
                      <div className="country-list">
                        {filteredCountries.map((country, index) => (
                          <div key={index} className="country-item-container">
                            <Link onClick={ClickHandler} to={country.path}>
                              <div className="country-item">
                                <div className="flag">
                                  <img src={country.flag} alt={`${country.name} Flag`} />
                                </div>
                                <div className="country-info">
                                  <span className="country-name">{country.name}</span>
                                  <span className="currency-code">{country.code} - {country.symbol}</span>
                                </div>
                              </div>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  </li>
                </ul>

                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/help">
                      Help
                    </Link>
                  </li>
                </ul>

                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </nav>

              {/* ===== DESKTOP BUTTONS ===== */}
              <div className="header-contact d-none d-md-flex align-items-center">
                <a
                  href="https://tigrispay.com/app/sign-up"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="thm-btn thm-btn--aso thm-btn--header-black"
                >
                  Sign Up
                </a>

                <a
                  href="https://tigrispay.com/app/app-login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="thm-btn thm-btn--aso thm-btn--header-black ms-3"
                >
                  Log In
                </a>
              </div>

              {/* ===== MOBILE MENU ===== */}
              <div className="xb-header-wrap">
                <div
                  className={`xb-header-menu ${mobailActive ? "active" : ""}`}
                >
                  <div className="xb-header-menu-scroll lenis lenis-smooth">
                    <div
                      className="xb-menu-close xb-hide-xl xb-close"
                      onClick={() => setMobailState(!mobailActive)}
                    ></div>

                    {/* ===== MOBILE LOGO LEFT ALIGNED ===== */}
                    <div className="xb-logo-mobile xb-hide-xl mb-3 text-start ps-3">
                      <Link onClick={ClickHandler} to="/" rel="home">
                        <img
                          src={logo}
                          alt="TigrisPay Mobile Logo"
                          style={{ maxWidth: "120px" }}
                        />
                      </Link>
                    </div>

                    {/* MOBILE NAVIGATION */}
                    <nav className="xb-header-nav">
                      <MobileMenu />

                      {/* ===== MOBILE BUTTONS (SAME SIZE) ===== */}
                      <div className="mobile-auth-buttons d-xl-none mt-4  d-flex flex-row align-items-center gap-3">
                        <a
                          href="https://tigrispay.com/app/sign-up"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="thm-btn thm-btn--aso w-100   text-center"
                          style={{
                            borderRadius: "30px",
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          Sign Up
                        </a>
                        <a
                          href="https://tigrispay.com/app/app-login"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="thm-btn thm-btn--aso w-100  text-center"
                          style={{
                            borderRadius: "30px",
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          Log In
                        </a>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>

              <div className="xb-header-menu-backdrop"></div>
            </div>

            {/* ===== MOBILE MENU BUTTON ===== */}
            <div className="header-bar-mobile side-menu d-xl-none">
              <button
                className="xb-nav-mobile"
                onClick={() => setMobailState(!mobailActive)}
              >
                <i className="far fa-bars"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
